import axios, { AxiosResponse, AxiosRequestConfig, AxiosError } from 'axios';
import { Toast } from 'vant';
import { getChannelIdOrSetChannelId } from '../common';
import { storage } from '@/utils/storage';
import { isEmpty, isObject } from 'lodash-es';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import CryptoJS from 'crypto-js';
import type { IObjStr } from '@/utils/http';
import { SIGNKEY, API_BASE_URL, ENSKEY, IVKEY } from './axiosKeyConfig';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import md5 from 'md5';
import { useMyLoading } from '@/store/modules/loading';
import pinia from '@/store';
const useMyLoading_ = useMyLoading(pinia);

axios.defaults.timeout = 1000 * 60;
axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8';
// 创建axios实例
const service = axios.create({
  // 根据不同env设置不同的baseURL
  baseURL: API_BASE_URL,
});

// axios实例拦截请求
service.interceptors.request.use(
  (config: AxiosRequestConfig) => {
    const timestamps = new Date().getTime();
    let sign = `timestamps=${timestamps}&signKey=${SIGNKEY}`;
    // 排序拼接并做md5加密
    const hasSignObj = {
      ...config.data,
    };
    let newhasSignResult = '';
    const hasSignArr = Object.keys(hasSignObj).sort();
    const regCt = new RegExp('application/x-www-form-urlencoded');
    let token_ = storage.getItem('token', 1) || '';
    if (
      config.url == '/ysr-h5-app/web/buried/user/visit' &&
      config.data.currentPageCode == 'ysr100000'
    ) {
      token_ = '';
    }
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    if (regCt.test(config.headers['Content-Type'])) {
      /**form-data*/
      let newhasSignArr = '';
      hasSignArr.map((i) => {
        const re =
          /select|update|delete|truncate|join|union|exec|insert|drop|count|<html|<script|alert/i;
        if ((hasSignObj[i] || hasSignObj[i] == 0) && !re.test(hasSignObj[i])) {
          newhasSignArr += i + '=' + hasSignObj[i] + '&';
        }
      });
      newhasSignResult = `${newhasSignArr}${sign}`;
    } else {
      /**application/json*/
      const newObj: {
        [key: string]: string | number | object;
      } = {};
      hasSignArr.map((i) => {
        const re =
          /select|update|delete|truncate|join|union|exec|insert|drop|count|<html|<script|alert/i;
        if ((hasSignObj[i] || hasSignObj[i] == 0) && !re.test(hasSignObj[i])) {
          newObj[i] = hasSignObj[i];
        }
      });
      const newObjSing = JSON.stringify(newObj);
      newhasSignResult = `${isEmpty(newObj) ? '' : newObjSing + '&'}${sign}`;
      const data = {
        ...config.data,
      };
      if (!isEmpty(data)) {
        // console.log('request----', config.data, config.url);
        // console.log(newObjSing + 'newData+++++++++++++')
        const key = CryptoJS.enc.Utf8.parse(ENSKEY);
        const iv = CryptoJS.enc.Utf8.parse(IVKEY);
        const ciphertext = CryptoJS.AES.encrypt(newObjSing, key, {
          iv,
          mode: CryptoJS.mode.CBC,
          padding: CryptoJS.pad.Pkcs7,
        });
        const DataBase64 = ciphertext.toString(); //Base64.encode(ciphertext.toString());
        config.data = 'enc-' + DataBase64;
      }
    }
    sign = md5(newhasSignResult).toUpperCase();
    const noChannelId = storage.getItem('noChannelId', 2);
    const channelInfo = <IObjStr>storage.getItem('channelIdInfo', 2);
    config.headers = {
      osVersion: 5,
      ...config.headers,
      channelId:
        config.url == '/ysr-h5-app/web/user/login' && noChannelId
          ? ''
          : storage.getItem('channelId', 2) || '',
      channelType: storage.getItem('channelType', 2) || '',
      channelUid: getChannelIdOrSetChannelId(),
      appName: channelInfo?.appName || '',
      flag: storage.getItem('flag', 2) || '',
      platform: storage.getItem('platform', 2) || 'H5',
      source: 16,
      token: token_,
      xdToken: storage.getItem('xdToken', 1) || '',
      city: storage.getItem('cityChoose', 2)
        ? encodeURI(<string>storage.getItem('cityChoose', 2))
        : '',
      locationCity: storage.getItem('localCity', 2)
        ? encodeURI(<string>storage.getItem('localCity', 2))
        : '',
      sign: sign,
      timestamps: timestamps,
    };
    return config;
  },
  (error: AxiosError) => {
    return Promise.reject(error);
  }
);
function enc(valueText: string): string {
  const aesKey = 'enc-';
  const index = valueText.indexOf(aesKey);
  const result = valueText.substring(index + aesKey.length, valueText.length);
  const key = CryptoJS.enc.Utf8.parse(ENSKEY);
  const iv = CryptoJS.enc.Utf8.parse(IVKEY);
  // console.log(Base64.decode(result))
  const decrypt = CryptoJS.AES.decrypt(result, key, {
    iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });
  return decrypt.toString(CryptoJS.enc.Utf8);
}

// axios实例拦截响应
service.interceptors.response.use(
  // 2xx时触发
  (response: AxiosResponse<string>) => {
    let result: {
      code?: string;
      msg?: string;
      data?: string | object;
      success?: boolean;
    } = {};
    if (isObject(response.data)) {
      result = response.data;
    } else {
      result = JSON.parse(enc(response.data));
    }
    console.log(
      'response------------',
      response.config.data && JSON.parse(enc(response.config.data)),
      result,
      response.config.url
    );
    const { code, msg, data } = result;
    switch (code) {
      case '1000':
        return result;
        break;
      case '10998':
        return result;
        break;
      case '10004': // 无权限
        Toast(msg);
        storage.removeItem('token', 1);
        storage.removeItem('tokenTime', 1);
        return Promise.reject(result);
        break;
      case '3000': //token无效
        Toast('系统异常!');
        return Promise.reject(result);
        break;
      case '5000': //token无效
        return Promise.reject(result);
        break;
      default:
        if (msg) {
          Toast(msg);
        }
        //if (!useMyLoading_.requestLoading) useMyLoading_.setRequestLoading(true);
        return Promise.reject(result);
        break;
    }
  },
  // 非2xx时触发
  (error: AxiosError) => {
    // Toast.fail('Network Error...');
    return Promise.reject(error);
  }
);

export type { AxiosResponse, AxiosRequestConfig };

export default service;
